export const objectToParam = (params: any) => Object.keys(params).map(key => key + '=' + params[key]).join('&');